// extracted by mini-css-extract-plugin
module.exports = {"icon":"TextIconButton_icon__3RiMk","text":"TextIconButton_text__2f08a","text-large":"TextIconButton_text-large__2d-Ki","wrapper":"TextIconButton_wrapper__2nGPh"};